import styled from 'styled-components';


export const Wrapper = styled.div`
  background: #FFC700;
  color: #2E305D;

`;